import request from '@/utils/request'

export function createBookingDeposit(data) {
  return request({
    url: '/booking-service/v1/deposit',
    method: 'post',
    data: data
  })
}
